/**
 * Shows errors at the respective position.
 * Example: If passed errors array contains a 'name' key, the error message will be placed below the Name field in the form
 * @param {Element} form
 * @param {Array} errors 
 */
export function HandleFormErrors(form, errors){
	const formFieldsMissing = form.querySelector('.fields-missing-message');

	Object.keys(errors).forEach((key) => {
		let error = errors[key];
		let inputName = key;

		if(key.includes('.')) {
			let parts = key.split('.');

			inputName = '';
			parts.forEach((part, index) => {
				if(index === 0)
					inputName += part;
				else inputName += '[' + part + ']';
			});

			error = "The field with an asterisk (*) attached is required."
		}

		let formElement = form.querySelector('[name="' + inputName + '"]');

		if (!formElement)
			formElement = form.querySelector('[name="' + inputName + '[]"]');

		if (!formElement)
			return;

		let formField = formElement.closest('.form-field');
		if(!formField)
			return;

		let inputError = formField.querySelector('.input-error');
		if(!inputError)
			return;
			
		inputError.innerHTML = error;
		inputError.classList.remove("hidden");
	});

	if(Object.keys(errors).length > 0 && formFieldsMissing != null)
		formFieldsMissing.classList.remove("hidden");
}

/**
 * Hides all error fields in the passed form by assigning the css class 'hidden' to each of them
 * @param {Element} form 
 */
export function HideErrorFields(form){
	const errorFields = form.querySelectorAll('.input-error');
	const formError = form.querySelector('.error-message');
	const formFieldsMissingError = form.querySelector('.fields-missing-message');

	errorFields.forEach((errorField) => {
		errorField.classList.add('hidden');
	});

	if(formError)
		formError.classList.add('hidden');

	if(formFieldsMissingError)
		formFieldsMissingError.classList.add('hidden');
}

/**
 * Searches for all inputs/textareas in the passed forms and clears the values
 * @param {Element} form 
 */
export function ClearAllFields(form){
	const formFields = form.querySelectorAll('input, textarea');

	formFields.forEach((field) => {
		field.checked = false;

		if(field.type !== 'checkbox' && field.type !== 'hidden')
			field.value = null;

		if(field.type == 'file')
			field.onchange();
	});
}